export default __webpack_public_path__ + "static/media/serenicare.aa687f4b.png";